import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar, { menuGroups } from '../components/admin/Sidebar';
import Header from '../components/admin/Header';
import { ToastProvider } from '../components/admin/ToastMessage';
import './AdminLayout.scss';

const AdminLayout = () => {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const location = useLocation();

    // Lấy tên module hiện tại cho breadcrumb
    const getModuleName = () => {
        const path = location.pathname;
        const match = path.match(/\/admin\/([^\/]+)/);
        if (match && match[1]) {
            const segment = match[1];
            if (segment === 'dashboard') return 'Dashboard';
            
            const fullPath = `/admin/${segment}`;
            for (const group of menuGroups) {
                const foundItem = group.items.find(item => item.path === fullPath);
                if (foundItem) {
                    return foundItem.name;
                }
            }
            
            // Fallback nếu không tìm thấy
            return segment.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        }
        return 'Dashboard';
    };

    return (
        <ToastProvider>
            <div className="admin-layout">
                <Sidebar collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} />
                <div className={`main-wrapper ${sidebarCollapsed ? 'collapsed' : ''}`}>
                    <Header moduleName={getModuleName()} />
                    <main className="main-content">
                        <Outlet />
                    </main>
                </div>
            </div>
        </ToastProvider>
    );
};

export default AdminLayout;